/// <amd-module name="Release/Landing/HubContent/ReleasesPivot" />
import * as React from "react";

import { css } from "VSSUI/Util";

import { VssComponent, IVssComponentProperties, IVssComponentContext } from "VSS/Platform/Layout";
import { ErrorBoundary } from "VSS/Platform/Components/ErrorBoundary";

import { ActiveDefinitionReferenceType } from "Release/Landing/DataProviderContracts";
import { ActiveReleases } from "Release/Landing/HubContent/Releases/ActiveReleases";
import { IReleasesFilterState } from "Release/Landing/HubContent/Filter/FilterTypes";
import { SelectPipelineView } from "./SelectPipelineView";
import * as Resources from "Release/Landing/Resources";
import { startScenario, PerfScenarios, endScenario, markTimeToInteractive } from "Release/Helpers/Performance";

import "VSS/LoaderPlugins/Css!RM:Release/Landing/HubContent/ReleasesPivot";

export interface IReleasesPivotProps extends IVssComponentProperties {
    definitionId: number;
    definitionName: string;
    definitionFolderPath: string;
    selectedFolderPath: string;
    isSearchedItem: boolean;
    isTabSwitchNavigation: boolean;
    definitionReferenceType: ActiveDefinitionReferenceType;
    filterState: IReleasesFilterState;
    fixedPaneSize: number;
    markTTICallback: () => void;
}

export class ReleasesPivot extends VssComponent<IReleasesPivotProps, {}>{
    constructor(props: IReleasesPivotProps, context: IVssComponentContext) {
        super(props, context);

        startScenario(context.pageContext, PerfScenarios.ReleasesPivot, false);
    }

    public componentWillReceiveProps(newProps: IReleasesPivotProps) {
        if (!newProps.isTabSwitchNavigation && newProps.definitionId !== this.props.definitionId) {
            // Start perf scenario on selection change in leftPanel
            startScenario(this.context.pageContext, PerfScenarios.ReleasesPivot, false);
            this._releasesLoadMarked = false;
        }
    }

    public render(): React.ReactNode {
        if (this.props.definitionId <= 0 && !this.props.selectedFolderPath) {
            return (<SelectPipelineView resourceText={Resources.ReleasesLowerCase} />);
        }

        return (<ErrorBoundary handlerComponentType="tfs.page-error-handler">
            <ActiveReleases
                definitionId={this.props.definitionId}
                definitionName={this.props.definitionName}
                definitionFolderPath={this.props.definitionFolderPath}
                selectedFolderPath={this.props.selectedFolderPath}
                isSearchedItem={this.props.isSearchedItem}
                definitionReferenceType={this.props.definitionReferenceType}
                filterState={this.props.filterState}
                cssClass={css(this.props.className, "releases-pivot-content")}
                markTTICallback={this.props.markTTICallback}
            />
        </ErrorBoundary>);
    }

    private _endPerfScenario = () => {
        // End ReleasesHub perf scenario when Releases loading is complete
        if (!this.props.isTabSwitchNavigation) {
            this.props.markTTICallback();
        }

        //End ReleasesPivot scenario when -
        // 1. there is a selection change in left panel
        // 2. or initial page load is complete
        // 3. or Right pivot change
        if (!this._releasesLoadMarked) {
            endScenario(this.context.pageContext, PerfScenarios.ReleasesPivot, false);
            this._releasesLoadMarked = true;
        }
    }

    private _releasesLoadMarked: boolean = false;
}
